"use client"

import {useSearchParams} from "next/navigation";
import {useEffect} from "react";
import {captureSmsTag} from "@/lib/utils/smsTags";
import {safeLocalStorage} from "@/lib/utils/storage";
import {captureAttribution, getAttributionProperties} from "@/lib/analytics/attribution";
import {registerSuperProperties} from "@/lib/analytics/mixpanel";

export default function RouteObserver() {
    const searchParams = useSearchParams();
    const ref = searchParams.get("ref");
    const traffic = searchParams.get("traffic");
    const tag = searchParams.get("tag");

    useEffect(() => {
        if (ref) {
            safeLocalStorage.setItem("ref", ref);
        }
        if (traffic) {
            safeLocalStorage.setItem("traffic", traffic);
        }
        // AC-695: capture the SMS campaign tag (validate + normalize + accumulate)
        // and report the click once per browser session. Fire-and-forget.
        captureSmsTag(tag);
    }, [ref, traffic, tag]);

    // AC-711: first-touch attribution (spec §5–6). Captured here rather than in
    // <MixpanelInitializer/> because this is the component that already sees the
    // landing query string, and the capture must happen whether or not analytics
    // are enabled — the partner link is only in the URL once, and a visitor who
    // has not yet accepted the cookie banner must still be attributable to the
    // partner when they later accept and deposit.
    //
    // Registering here too (in addition to the initializer's bag) means the very
    // first events of an attributed landing already carry the block, regardless
    // of which of the two components' effects React flushes first.
    useEffect(() => {
        captureAttribution(searchParams);
        registerSuperProperties(getAttributionProperties());
    }, [searchParams]);

    return <></>
}
